import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  section: number,
  question: number,
  _type: number,
  value_type: number,
  value: string | null
}


export const useUpdateCondition = () => {
  const { authHeader } = useAuth();
  return useMutation(({ params, id }: { params: Params; id: number }) => {
    return axios.patch(
      `${env.verifyServiceUrl}individual/section_condition/${id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
